import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Button,
} from "@mui/material";

import { TableCell } from "components/TableCell";

import { i18n } from "services/i18nService";

export function UpsRatesTable(props) {
  const { rates, selectRate } = props;

  if (!rates) {
    return null;
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ verticalAlign: "bottom" }}>
            <TableCell>{i18n("upsShipment.Service")}</TableCell>
            <TableCell>{i18n("upsShipment.GuaranteedBy")}</TableCell>
            <TableCell sx={{ textAlign: "right" }}>
              {i18n("upsShipment.Cost")}
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rates.map(({ cost, date, service }, i) => (
            <TableRow key={i}>
              <TableCell>{service}</TableCell>
              <TableCell>{date}</TableCell>
              <TableCell sx={{ textAlign: "right" }}>{cost}</TableCell>
              <TableCell sx={{ textAlign: "right" }}>
                <Button size="small" onClick={() => selectRate(service)}>
                  {i18n("upsShipment.UseThisService")}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
